module.exports = __webpack_public_path__ + "img/goods-manage.85c656d3.svg";